import { render } from "./input-date.vue?vue&type=template&id=fcb57dd0"
import script from "./input-date.vue?vue&type=script&lang=js"
export * from "./input-date.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src901110558/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__